var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "navbar-content grid grid__base" }, [
    _c("div", { staticClass: "navbar-content--container grid--container" }, [
      _c("div", { staticClass: "navbar-content--row grid--row" }, [
        _c(
          "a",
          {
            staticClass: "u-reset grid--col navbar-content--brand-link",
            attrs: { href: "/" }
          },
          [
            _c("img", {
              attrs: {
                alt: _vm.brandLogoAlt,
                src: _vm._f("staticPath")("img/im-logo-desktop-black.svg")
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "navbar-content--list u-reset grid--col" },
          _vm._l(_vm.items, function(item, idx) {
            return _c(
              "li",
              { key: idx, staticClass: "navbar-content--list-item" },
              [_c("navbar-item", _vm._b({}, "navbar-item", item, false))],
              1
            )
          })
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-01d986f1", { render: render, staticRenderFns: staticRenderFns })
  }
}